import React from "react";
import PropTypes from "prop-types";
import radium from "radium";
import Flyout from "backpack-ui/dist/components/flyout";
import TextHeading from "backpack-ui/dist/components/text/textHeading";
import propTypes from "backpack-ui/dist/utils/propTypes";
import colors from "backpack-ui/dist/styles/colors";
import mq from "backpack-ui/dist/styles/mq";
import { fontSizeBodyArticleSmall, lineHeightBodySmall } from "backpack-ui/dist/styles/typography";

const styles = {
  base: {
    position: "absolute",
    margin: "0 auto",
    textAlign: "center",
    maxWidth: "350px",
    color: colors.textOverlay,
    backgroundColor: colors.linkPrimary,
    cursor: "pointer",
    paddingLeft: "28px",
    paddingRight: "28px",
    paddingBottom: "24px",
    paddingTop: "24px",
    [`@media (max-width: ${mq.max["360"]})`]: {
      maxWidth: "95%",
    },
  },
  headline: {
    marginBottom: "8px",
    color: colors.textOverlay,
  },
  description: {
    fontSize: fontSizeBodyArticleSmall,
    lineHeight: lineHeightBodySmall,
  },
};

const DiscoveryFlyout = ({ headline, description, arrowPosition, style }) => (
  <Flyout
    size="medium"
    arrow="up"
    arrowPosition={arrowPosition}
    style={Object.assign({}, styles.base, style)}
  >
    <div>
      <TextHeading
        weight="medium"
        level={6}
        size={6}
        style={styles.headline}
      >
        {headline}
      </TextHeading>
      <p
        style={styles.description}
      >
        {description}
      </p>
    </div>
  </Flyout>
);

DiscoveryFlyout.propTypes = {
  headline: PropTypes.string,
  description: PropTypes.string,
  arrowPosition: PropTypes.string,
  style: propTypes.style,
};

DiscoveryFlyout.defaultProps = {
  arrowPosition: "center",
};

export default radium(DiscoveryFlyout);



// WEBPACK FOOTER //
// ./assets/pois/components/featureDiscover/discoveryFlyout.jsx